import { useState, useEffect, useCallback } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import AlarmConfigForm from './components/AlarmConfigForm';
import NotificationMenu from './components/NotificationMenu';
import Page from '../../components/Page/Page';
import Headers from '../../components/Headers/Headers';
import Reload from '../../components/reload/reload';
import Api from '../../services/Api';
import '../DashMedidas/DashMedidas.css';
import '../../styles/SguUnitsPage.css';

const getOtherEquipmentsArray = (unit) =>
  Array.isArray(unit?.otherEquipments) ? unit.otherEquipments : [];

const hasAlrmEquipment = (unit) =>
  getOtherEquipmentsArray(unit).some(e => e.serialNumber?.toUpperCase().includes('ALRM'));

const getAlrmSerials = (unit) =>
  getOtherEquipmentsArray(unit)
    .filter(e => e.serialNumber?.toUpperCase().includes('ALRM'))
    .map(e => e.serialNumber);

const Alarm = () => {
  const [loading, setLoading] = useState(true);

  const allUnits = JSON.parse(localStorage.getItem('units')) ||
    [JSON.parse(localStorage.getItem('cooperative'))] ||
    [];

  const alrmUnits = allUnits.filter(hasAlrmEquipment);

  const [user] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [filteredUnits, setFilteredUnits] = useState(alrmUnits);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [alarmDataMap, setAlarmDataMap] = useState({});

  useEffect(() => {
    const allSerials = alrmUnits.flatMap(getAlrmSerials);

    const fetchAlarms = async () => {
      try {
        const { data } = await Api.post('/alarm/v1/filtered', { listSerialNumbers: allSerials });
        const map = {};
        data.forEach(alarm => { map[alarm.serialNumber] = alarm; });
        setAlarmDataMap(map);
      } catch (e) {
        console.error('Erro ao buscar alarmes:', e);
      } finally {
        setLoading(false);
        if (alrmUnits.length > 0) setSelectedUnit(alrmUnits[0]);
      }
    };

    if (allSerials.length > 0) {
      fetchAlarms();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAlrmEquipments = (unit) =>
    getAlrmSerials(unit).map(serial =>
      alarmDataMap[serial] ||
      getOtherEquipmentsArray(unit).find(e => e.serialNumber === serial)
    ).filter(Boolean);

  const handleAlarmUpdate = (updatedAlarm) => {
    setAlarmDataMap(prev => ({ ...prev, [updatedAlarm.serialNumber]: updatedAlarm }));
  };

  const handleSearchData = useCallback((value) => {
    setSearchValue(value);
    const upper = value.toUpperCase();
    const filtered = alrmUnits.filter(item =>
      item?.name?.toUpperCase().includes(upper) ||
      item?.email?.toUpperCase().includes(upper) ||
      item?.cnpj?.toUpperCase().includes(upper)
    );
    setFilteredUnits(filtered);
    setSelectedUnit(filtered.length > 0 ? filtered[0] : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const unitsHeaderRight = selectedUnit ? (
    <span className="dash-section-card__header-meta">1 selecionada</span>
  ) : null;

  return (
    <Page title="Alarmes">
      <Headers page="Alarmes" />
      {loading && <Reload />}

      <div className="dash-medidas-page dash-medidas-container sgu-units-page">
        <div className="dash-medidas-stack">
          <Row className="dash-medidas-grid g-3 sgu-units-main-row">
            <Col xs={12} md={4} lg={3} xl={3} className="sgu-units-col">
              <NotificationMenu
                user={user}
                units={filteredUnits}
                onUnitSelect={setSelectedUnit}
                onSearch={handleSearchData}
                selectedUnit={selectedUnit}
                searchValue={searchValue}
                headerRight={unitsHeaderRight}
              />
            </Col>

            <Col xs={12} md={8} lg={9} xl={9} className="sgu-units-content-col">
              <div className="dash-medidas-stack sgu-units-content-scroll">
                {selectedUnit ? (
                  <AlarmConfigForm
                    user={user}
                    unit={selectedUnit}
                    alarmEquipments={getAlrmEquipments(selectedUnit)}
                    onAlarmUpdate={handleAlarmUpdate}
                  />
                ) : (
                  <Alert variant="warning" className="text-center mb-0 sgu-empty-alert">
                    Selecione uma unidade para configurar os alarmes
                  </Alert>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </Page>
  );
};

export default Alarm;
